import { render, staticRenderFns } from "./items.vue?vue&type=template&id=5997dd9a&scoped=true&"
import script from "./items.vue?vue&type=script&lang=js&"
export * from "./items.vue?vue&type=script&lang=js&"
import style0 from "./items.vue?vue&type=style&index=0&id=5997dd9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5997dd9a",
  null
  
)

export default component.exports